class AccessibleVideo extends HTMLElement {
  constructor() {
    super();

    this.rootMargin = this.dataset.rootMargin || '0px';
    this.controlBtn = this.querySelector('[data-control-btn]');
    this.videoDiv = this.querySelector('[data-video-div]');
  }

  connectedCallback() {
    if (!this.videoDiv || !this.controlBtn) return;

    this.initLazyVideo();
    this.initAccessibleVideo();
  }

  initLazyVideo() {
    const divStyle = window.getComputedStyle(this.videoDiv);

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting !== true) return;
      if (divStyle.display == 'none') return;

      const newVideo = document.createElement('video');
      const newVideoSource = document.createElement('source');
      newVideoSource.setAttribute('type', 'video/mp4');

      this.copyAttributes(this.videoDiv, newVideo);

      newVideo.src = newVideo.getAttribute('data-src');
      this.videoDiv.parentNode.insertBefore(newVideo, this.videoDiv);
      this.videoDiv.parentNode.removeChild(this.videoDiv);
      newVideoSource.src = newVideo.src + '#t=0.001';
      newVideo.appendChild(newVideoSource);
    }, { threshold: [0], rootMargin: this.rootMargin });

    observer.observe(this.videoDiv);
  }

  initAccessibleVideo() {
    this.controlBtn.addEventListener('click', () => {
      const video = this.querySelector('video');

      if (!video) return;
      
      video.removeAttribute('controls');
      
      this.controlBtn.classList.toggle('play');
      if (video.paused) video.play();
      else video.pause();
    })
  }

  copyAttributes(source, target) {
    return Array.from(source.attributes).forEach(attribute => {
      target.setAttribute(
        attribute.nodeName,
        attribute.nodeValue,
      );
    });
  }  
}

if (!customElements.get('accessible-video')) {
  customElements.define('accessible-video', AccessibleVideo);
}